import React from 'react'

export default () => {
    return <i className="fa fa-spinner fa-spin" style={{ margin: 0 }} />
}
